<template>
  <LineChart :chartData="chartData" :options="options" />
</template>


<script setup>
import router from '@/router/index'
/*composables & states */
import { userUUID, clubUUID } from '@/shared/state';

import { defineProps, toRefs, ref, computed } from 'vue';
import { LineChart } from 'vue-chart-3';
import { Chart, registerables } from "chart.js";

Chart.register(...registerables);


const props = defineProps({
  chartData: {
    type: Object,
    default: null,
  },


});
let { chartData } = toRefs(props);
const options = ref({
  responsive: true,
  maintainAspectRatio: false,
  plugins: {

    title: {
      display: true,
      text: chartData.value.pluginsTitle ?? ''
    },
    legend: {
      position: 'top',
    },
  },
  scales: {
    x: {
      title: {
        display: true,
        text: chartData.value.scalesX ?? ''
      },
    },
    y: {
      title: {
        display: true,
        text: chartData.value.scalesY ?? ''
      },
      beginAtZero: true,
    },
  }
});




</script>
